/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgFloppyDiskArrowTopRightBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 4H11.5C10.6716 4 10 4.67157 10 5.5V8M20 9V12.5C20 13.3284 19.3284 14 18.5 14H18M16 8L22 2M22 6V2H18M12.7692 22V17.1538C12.7692 17.011 12.7125 16.8741 12.6116 16.7731C12.5106 16.6721 12.3736 16.6154 12.2308 16.6154H5.76923C5.62642 16.6154 5.48946 16.6721 5.38848 16.7731C5.2875 16.8741 5.23077 17.011 5.23077 17.1538V22M12.7692 8V11.7692C12.7692 11.912 12.7125 12.049 12.6116 12.15C12.5106 12.251 12.3736 12.3077 12.2308 12.3077H7.92308C7.78027 12.3077 7.6433 12.251 7.54233 12.15C7.44135 12.049 7.38462 11.912 7.38462 11.7692V8M16 20.9231C16 21.2087 15.8865 21.4826 15.6846 21.6846C15.4826 21.8865 15.2087 22 14.9231 22H3.07692C2.7913 22 2.51739 21.8865 2.31542 21.6846C2.11346 21.4826 2 21.2087 2 20.9231V12.7492C2.00119 12.4667 2.11335 12.196 2.31231 11.9954L5.99538 8.31231C6.19597 8.11335 6.46671 8.00119 6.74923 8H14.9231C15.2087 8 15.4826 8.11346 15.6846 8.31542C15.8865 8.51739 16 8.7913 16 9.07692V20.9231Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgFloppyDiskArrowTopRight = wrapIcon(SvgFloppyDiskArrowTopRightBase);
export default SvgFloppyDiskArrowTopRight;
